import { Component, AfterViewInit, ViewChild, OnInit } from '@angular/core';
import { MessageclientService } from '../../../../service/messageclient.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Device } from '@ionic-native/device/ngx';//获取手机硬件设备
import { Platform,IonItemSliding } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { WebParameterContext } from '../../../../model/common';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from "../../../../bizlogic/servicesbll";
import { GridBaseCase } from '../../grid/grid.base.case';
import { CommonService } from 'src/service/common.service';
declare var app;


@Component({
  selector: 'app-mz-plan',
  templateUrl: './mz-plan.component.html',
  styleUrls: ['./mz-plan.component.scss']
})
export class MzPlanComponent extends GridBaseCase implements AfterViewInit,OnInit {
  ch: any;//日历汉化配置
  data:Date;
  Today = {
    day: null,
    month: null,
    year: null
  };
  isCheckOldDate = false;//是否选中过去的日子
  checkDate: any = new Date();//选中的日期
  deleteSchedule:boolean = false;//删除日期
  /**
   * 所有日程
   */
  scheduleDate = [];
  scheduleDateString = "";

  /** 
   * 当前选中日程
  */
  currentSchedule = [];

  searchDate: any = null;//查询日期
  initGetData:boolean = true;
  @ViewChild(IonItemSliding) itemSliding: IonItemSliding;
  isAndroid4:boolean = false;//是否是安卓4以下
  isAndroid5Down:boolean = false;//是否是安卓5以下
  isAndroid5:boolean = false;//是否是安卓5
  constructor(
    private msg: MessageclientService,
    private activaRouter: ActivatedRoute,
    private platform: Platform,
    private http: HttpCustomerService,
    private router: Router,
    private device:Device,
    public com: CommonService
  ) {
    super();
    const d = new Date();
    this.Today.year = d.getFullYear();
    this.Today.month = d.getMonth();
    this.Today.day = d.getDate();
    this.ch = {
      /** 每周第一天，0代表周日 */
      firstDayOfWeek: 0,
      /** 每周天数正常样式 */
      dayNames: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
      /** 每周天数短样式（位置较小时显示） */
      dayNamesShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      /** 每周天数最小样式 */
      dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
      /** 每月月份正常样式 */
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      /**每月月份短样式 */
      monthNamesShort: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      today: '今天',
      clear: '清除'
    };
  }

  ngAfterViewInit() {
    const that = this;
    let date = {
      year: that.Today.year,
      month: that.Today.month + 1
    }
    // setTimeout(()=>{
    //   that.getSearchDate(date);
    // },100);
    that.timeOutSearchDate(date);

    if(that.platform.is("cordova")){
      if(that.platform.is("android")){
        if(that.device.version){//版本号存在
          if(that.device.version.toString().startsWith("5")){//当前版本小于等于5.0
            that.isAndroid5 = true;//等于5
            that.isAndroid5Down = true;
            that.isAndroid4 = false;
          }else if(that.device.version.toString().startsWith("4")){//当前版本小于等于4.0
            that.isAndroid5Down = true;//小于5.0
            that.isAndroid4 = true;
          }else if(that.device.version.toString().startsWith("3")){//当前版本小于等于3.0
            that.isAndroid5Down = true;//小于5.0
            that.isAndroid4 = true;
          }
        }
      }
    }
  }

  ngOnInit(){
    // const that = this;
    // that.getScheduleList();
  }

  drag($event){
    console.log($event);
  }

  /**
   * 获取日程列表
   */
  getScheduleList(loads) {
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const type = that.activaRouter.snapshot.paramMap.get('type');
    const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    let body = new WebParameterContext();

    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    
    // body.RequestBody =JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id});
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = PageName;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let _id = that.com.GetAccount.Id;
    if(type == "view"){
      _id = id;
    }
    body.RequestBody = JSON.stringify({ "a_VisitDate": that.searchDate, "a_FK_SystemUser_ID": _id });
    // body.RequestBody= JSON.stringify({"userId":that.com.GetAccount.Id});
    body = HandleWebParameterContextBeforeDBRequest(body);
    if (!body.ResponseMessage.Success) {
      loads.dismiss();
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      data = HandleServerContextAfterDBRequest(body, data);
      that.scheduleDate = [];
      if (data.ResponseMessage.Success) {
        loads.dismiss();
        // that.scheduleDate = data.Status.Datas;
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
            that.element.selectItemList.selectItem.forEach((element, index) => {
              if (element.bindingField) {
                objfield[element.bindingField] = item[element.field];
              }
            });
            that.scheduleDate.push(objfield);
        });
        // that.getCurrentSchedule(that.checkDate);
        if(that.initGetData || that.deleteSchedule){
          that.deleteSchedule = false;
          that.initGetData = false;
          that.getCurrentSchedule(that.checkDate);
        }
      }
    }).catch(error => {
      loads.dismiss();
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
      console.log(error);
      // that.msg.Alert(error.error.ResponseMessage.ErrorMessage).then(data => {
      //   //that.router.navigate(["/login"]);
      // })
    })
  }

  //删除临时计划
  deleteData(item){
    const that = this;
    let isdd:boolean=false;//判断是否是督导；
    that.com.GetAccount.Roles.forEach(r=>{
      if(r.Code==="1003"){
        isdd=true;
        // that.isCheckOldDate=true;
      }
    });
    if(isdd){
      that.msg.Alert("督导不可以执行删除操作");
       return;
    }
    that.msg.Confirm('确认删除？').then(data=>{
      if(data){
        that.itemSliding.closeOpened();
        const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
        let body = new WebParameterContext();
    
        if (that.element.selectItemList.gridViewConfigName) {
          body.ConfigName = that.element.selectItemList.gridViewConfigName;
        } else if (that.ConfigName) {
          body.ConfigName = that.ConfigName;
        }
        body.OpType = "delete";
        body.ConfigType = "form";
        body.Client.PageName = PageName;
        body.Client.ApiType = "Element";
        body.Client.Name = PageName;
        body.Client.ClientType = 2;
        if (that.platform.is("android")) {
          body.Client.ClientType = 0;
        } else if (that.platform.is("ios")) {
          body.Client.ClientType = 1;
        }
        
        body.RequestBody= JSON.stringify({"a_ID":item.ID});
        body = HandleWebParameterContextBeforeDBRequest(body);
        if (!body.ResponseMessage.Success) {
          that.msg.Alert(body.ResponseMessage.ErrorMessage);
          return;
        }
        that.msg.Loading("数据加载中...").then(loads=>{

          that.http.post(app.DEFAULTURL, body).then(data => {
            loads.dismiss();
            data = HandleServerContextAfterDBRequest(body, data);
            if (data.ResponseMessage.Success) {
              setTimeout(()=>{
                that.getScheduleList(loads);
              },100);
              that.deleteSchedule = true;
            }
          }).catch(error => {
            console.log(error);
            loads.dismiss();
            that.msg.Alert(error.ResponseMessage.ErrorMessage);
            // that.msg.Alert(error.error.ResponseMessage.ErrorMessage).then(data => {
            //   //that.router.navigate(["/login"]);
            // })
          })
          loads.present();
        })
      }
    })
    
  }
  /**
* 下拉刷新数据
* @param event
*/
  //  doRefresh(event) {
  //   this.getScheduleList();
  //   event.target.complete();
  // }



  /**
   * 获取当天日程
   */
  getCurrentSchedule(day) {
    console.log("454545");
    let that = this;
    that.currentSchedule = [];
    that.com.GetAccount.Roles.forEach(r=>{
      if(r.Code==="1003"){
        that.isCheckOldDate=true;
      }
    });
    let d = this.DateFormat(day);
    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(d) > -1) {
        that.currentSchedule.push(item);
      }
    })
  }


  /**
   * 选中日期
   * @param ev 
   * @param d 
   */
  DateSelect(ev, d) {
    let that = this;
    this.checkDate = ev;
    this.getCurrentSchedule(this.checkDate);

    const d1 = new Date(ev.toString().replace(/-/g,"/"));
    let checkDay = {};
    checkDay['year'] = d1.getFullYear();
    checkDay['month'] = d1.getMonth();
    checkDay['day'] = d1.getDate();
    that.isCheckOldDate = this.isOldDate(checkDay);
    that.com.GetAccount.Roles.forEach(r=>{
      if(r.Code==="1003"){
        that.isCheckOldDate=true;
      }
    });
    // this.msg.Show(ev.getDate());
    let monthDom = document.getElementsByClassName("ui-datepicker-month");
    let cMonth = checkDay['month'];
    if(monthDom.length > 0){
      cMonth = monthDom[monthDom.length-1]['innerText'].replace('月', '');
    }
    if ((d1.getMonth() + 1) != parseInt(cMonth)) {
      that.currentSchedule = [];//清除选中天的拜访计划
      let date = {
        year: d1.getFullYear(),
        month: d1.getMonth() + 1
      }
      // setTimeout(()=>{
      //   that.getSearchDate(date);
      // },200)
      that.timeOutSearchDate(date);
      that.initGetData = true;
    }
  }


  /**
   * 判断日期是否存在
   * @param day 
   */
  getSchedule(date) {
    let date1 = '';
    if (!date.year) { return false; } else {
      date1 = date.year + '-' + ((date.month + 1)<10? '0'+ (date.month + 1):(date.month + 1)) + '-' + (date.day < 10? '0'+date.day:date.day);
    }
    let isSchedule = false;
    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(date1) > -1) {
        isSchedule = true;
      }
    })
    return isSchedule;
  }

  /**
   * 是否是过去的日期
   * @param date 
   */
  isOldDate(date) {
    
    if (date) {
      if (date.year < this.Today.year) {
        return true;
      } else if (date.year == this.Today.year) {
        if (date.month < this.Today.month) {
          return true;
        } else if (date.month == this.Today.month) {
          if (date.day < this.Today.day) {
            return true;
          }
        }
      }
    }
    return false;
  }

  /**
   * 查看日程详情
   * @param item 选中的日程
   */
  scheduleDetail(item) {
    // this.router.navigateByUrl("/tabs/contact/CalendarForm/view/" + item['id']);
    this.com.Go("/tabs/contact/CalendarForm/view/" + item['id']);
  }

  addPlan() {
    if(this.checkDate){
      localStorage.removeItem("setMap");
      localStorage.setItem('PlanMakingListDate',this.DateFormat(this.checkDate));
      this.com.setHistoryUrl();
      this.com.Go("/tabs/contact/PlanMakingList/plan/"+this.com.getNowDatetime);
    }else{
      this.msg.Alert('请选择日期');
    }
  }

  /**
   * 格式化日期
   * @param date 日期
   */
  DateFormat(dateFormat) {
    let date = dateFormat;
    if (date) {
      date = new Date(date.toString().replace(/-/g,"/"));
    } else {
      return;
    }
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    if (m < 10) {
      m = '0' + m;
    }
    let d = date.getDate();
    if (d < 10) {
      d = '0' + d;
    }
    return y + '-' + m + '-' + d;
  }

  /**
   * 月份改变
   * @param event 
   */
  monthChange($event) {

    const that = this;
    that.checkDate = null;
    that.currentSchedule = [];//清除选中天的拜访计划
    // setTimeout(() => {
    //   that.getSearchDate($event);
    // },200)
    that.timeOutSearchDate($event);
  }

  /**
   * 设置月份查询条件
   * @param date 
   */
  getSearchDate(date,loads) {
    const that = this;
    const d = date;
    let timerI = 0;
    let timer = setInterval(()=>{
      let domList:any = document.getElementsByClassName("ui-datepicker-calendar");
      timerI++;
      if(domList.length == 0){
        if(timerI < 10){
          return;
        }else{
          clearInterval(timer);
        }
      }else{
        clearInterval(timer);
      }
      
      let dom = null;
      const l = domList.length;
      if(l > 0){
        dom = domList[l-1];
      }else{}
      
      let timerI2 = 0;
      let timer2 = setInterval(()=>{
        const beginEle = dom.children[1].children[0].children[0];
        const endEle = dom.children[1].lastElementChild.lastElementChild;
        timerI2++;
        if(!beginEle && !endEle){
          if(timerI2 < 10){
            return;
          }else{
            clearInterval(timer2);
          }
        }else{
          clearInterval(timer2);
        }
        const beginDay = beginEle.children[0].children[0]['innerText'].replace(/(^\s*)|(\n*)|(\s*$)/g, "");
        const endDay = endEle.children[0].children[0]['innerText'].replace(/(^\s*)|(\n*)|(\s*$)/g, "");
        let beginMonth = beginEle.getAttribute("class").indexOf("ui-datepicker-other-month") >= 0 ? (d.month - 1) : (d.month);
        let endMonth = endEle.getAttribute("class").indexOf("ui-datepicker-other-month") >= 0 ? (d.month + 1) : (d.month);
        let beginYear = d.year;
        let endYear = d.year;
        if (beginMonth == 0) {
          beginMonth = 12;
          beginYear = d.year - 1;
        } else if (endMonth == 13) {
          endMonth = 1;
          endYear = d.year + 1;
        }
    
        const beginDate = beginYear + '-' + beginMonth + '-' + beginDay + ' 00:00:00';
        const endDate = endYear + '-' + endMonth + '-' + endDay + ' 23:59:59';
        this.searchDate = that.com.BetweenDate(beginDate, endDate);
        that.getScheduleList(loads);
      },400);
    },400);
  }

  timeOutSearchDate(date){
    const that = this;
    that.msg.Loading("数据加载中...").then(loads=>{
      setTimeout(() => {
        that.getSearchDate(date,loads);
      },200);
      loads.present();
    })
  }

}




